var _g, _path, _path2, _path3, _line, _line2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 100,
    viewBox: "0 0 74 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1717 12.0007L55.2219 7.05093L56.6361 5.63672L63.0001 12.0007L56.6361 18.3646L55.2219 16.9504L60.1717 12.0007Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1717 12.0007L55.2219 7.05093L56.6361 5.63672L63.0001 12.0007L56.6361 18.3646L55.2219 16.9504L60.1717 12.0007Z",
    fill: "#78C15A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82812 83.4872V89.7201H13.9834V94.9143C13.9834 95.4882 14.4483 95.9531 15.0223 95.9531H21.2553C21.8292 95.9531 22.2941 95.4882 22.2941 94.9143V89.7201H51.3813V94.9143C51.3813 95.4882 51.8462 95.9531 52.4201 95.9531H58.6531C59.2271 95.9531 59.692 95.4882 59.692 94.9143V89.7201H63.8473V83.4872H9.82812Z",
    fill: "#78C15A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5647 66.8658C27.8455 66.8658 26.4482 68.2631 26.4482 69.9823V81.4098H47.2248V69.9823C47.2248 68.2631 45.8276 66.8658 44.1083 66.8658H29.5647ZM45.1475 79.3318H28.5262V77.2541H45.1475V79.3318ZM45.1475 75.1765H28.5262V73.0988H45.1475V75.1765ZM45.1475 71.0212H28.5262V68.9435H45.1475V71.0212Z",
    fill: "#78C15A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3722 69.9827C24.3722 67.1181 26.7018 64.7886 29.5664 64.7886H44.11C46.9746 64.7886 49.3041 67.1181 49.3041 69.9827V81.4102H61.7701V73.0995C61.7701 70.8037 59.9106 68.9442 57.6148 68.9442V36.8133L60.7364 34.733V29.4688L54.384 33.9721C53.8049 34.3564 53.4595 35.0057 53.4595 35.7017V46.09C53.4595 42.6463 50.6702 39.857 47.2265 39.857H26.4499C23.0373 39.857 20.2714 42.5996 20.2221 45.9991L20.2195 35.7019C20.2195 35.0059 19.8715 34.3593 19.2949 33.9723L12.9451 29.4689V34.7332L16.0668 36.8135V68.9444H16.0616C13.7658 68.9444 11.9062 70.8039 11.9062 73.0997V81.4104H24.3722L24.3722 69.9827ZM57.6148 73.0992V77.2545H51.3818V73.0992H57.6148ZM37.8767 50.2449H51.3811V58.5556H37.8767V50.2449ZM22.2939 77.2545H16.0609V73.0992H22.2939V77.2545ZM22.2939 50.2449H35.7984V58.5556H22.2939V50.2449Z",
    fill: "#78C15A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 61,
    y2: 12,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 1,
    x2: 65,
    y2: 25,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8283 11.9993L18.7781 16.9491L17.3639 18.3633L10.9999 11.9993L17.3639 5.6354L18.7781 7.0496L13.8283 11.9993Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8283 11.9993L18.7781 16.9491L17.3639 18.3633L10.9999 11.9993L17.3639 5.6354L18.7781 7.0496L13.8283 11.9993Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 24,
    y2: -1,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 10 2)",
    stroke: "#78C15A",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 27 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 27 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTWidth);
export default __webpack_public_path__ + "static/media/T-WIDTH.bf49d3eda46ccce526721a51d9eea0a1.svg";
export { ForwardRef as ReactComponent };